import { Adjustment, NextArray, RoomOptions } from 'type';
import { RoomUtil } from 'utils';

const applySelected = (
  adjustments: NextArray<Adjustment>,
  selectedAdjustments: RoomOptions['adjustments']
) =>
  !adjustments
    ? []
    : adjustments.map((adjustment) =>
        selectedAdjustments && selectedAdjustments[adjustment.category]
          ? {
              ...adjustment,
              selected: RoomUtil.hasEqualSlug(
                adjustment,
                selectedAdjustments[adjustment.category]
              ),
            }
          : {
              ...adjustment,
              selected: adjustment.defaultSelected,
            }
      );

export const AdjustmentFactory = {
  applySelected,
};
